import type { IconNode } from '../types';

/**
 * @name shave-face
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTAgMjBhNyA3IDAgMCAxLTctN1Y0YzAtLjYuNC0xIDEtMWg2IiAvPgogIDxwYXRoIGQ9Ik03IDdoLjAxIiAvPgogIDxwYXRoIGQ9Ik0xMSAxM2gzVjRjMC0uNi40LTEgMS0xaDYiIC8+CiAgPHBhdGggZD0iTTE4IDdoLjAxIiAvPgogIDxwYXRoIGQ9Ik0xNCAxOXYyIiAvPgogIDxwYXRoIGQ9Im0xOCAxNyAxLjUgMS41IiAvPgogIDxwYXRoIGQ9Ik0xOSAxM2gyIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/shave-face
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const shaveFace: IconNode = [
  ['path', { d: 'M10 20a7 7 0 0 1-7-7V4c0-.6.4-1 1-1h6', key: '6tzej9' }],
  ['path', { d: 'M7 7h.01', key: '7u93v4' }],
  ['path', { d: 'M11 13h3V4c0-.6.4-1 1-1h6', key: 'vnigfz' }],
  ['path', { d: 'M18 7h.01', key: 'uqb172' }],
  ['path', { d: 'M14 19v2', key: 'pemx32' }],
  ['path', { d: 'm18 17 1.5 1.5', key: '1j2bil' }],
  ['path', { d: 'M19 13h2', key: '1gch44' }],
];

export default shaveFace;
